module.exports = __webpack_public_path__ + "img/hearingaid1.5e0670d9c48a8d8b7c0b73e175f95240.png";